import type { ReserveTime } from "@/types/orders-detail.type"

export function formatNumToStr(value: any) {
  let result: any
  if (typeof value === 'number' || !Number.isNaN(value)) {
    result = Number(value)
    const isDecimal = parseInt(result, 10) !== parseFloat(result)
    if (isDecimal) {
      // 有小数点
      result = result.toFixed(2)
    }
  } else {
    result = value
  }
  return result
}

export function recognizePhone(text: any) {
  const regx = new RegExp('(1[d]{10}|0[d]{2,3}-[d]{7,8}|[4|8]00[-]?[d]{3}[-]?[d]{4})', 'g')
  const phoneNums = text.split(regx)
  let elements = []
  if (phoneNums.length) {
    elements = phoneNums.map(function (text: any) {
      return {
        type: regx.test(text) ? 'phone' : 'normal',
        text: text
      }
    })
  }
  return elements
}

function formatNumber(n: any) {
  n = n.toString()
  return n[1] ? n : '0' + n
}

function fillNumber(number: number, length: number) {
  const s = number + ''
  const arr = []
  const len = length - s.length
  if (len > 0) {
    for (let i = 0; i < len; i++) {
      arr.push(0)
    }
    return arr.join('') + s
  } else {
    return s.substring(-len, s.length)
  }
}

export function formatTime(date: Date, pattern?: any) {
  const year = date.getFullYear()
  const month = date.getMonth() + 1
  const day = date.getDate()
  const hour = date.getHours()
  const minute = date.getMinutes()
  const second = date.getSeconds()
  const map = {
    y: year,
    M: month,
    d: day,
    h: hour % 12,
    H: hour,
    m: minute,
    s: second
  }
  if (!pattern) {
    return (
      [year, month, day].map(formatNumber).join('-') +
      ' ' +
      [hour, minute, second].map(formatNumber).join(':')
    )
  }
  return pattern.replace(
    /(y+)?(M+)?(d+)?(h+)?(H+)?(m+)?(s+)?/g,
    (
      match: any,
      g1: string | any[],
      g2: string | any[],
      g3: string | any[],
      g4: string | any[],
      g5: string | any[],
      g6: string | any[],
      g7: string | any[]
    ) => {
      const ret = []
      if (g1) {
        ret.push(fillNumber(map.y, g1.length))
      }
      if (g2) {
        ret.push(fillNumber(map.M, g2.length))
      }
      if (g3) {
        ret.push(fillNumber(map.d, g3.length))
      }
      if (g4) {
        ret.push(fillNumber(map.h, g4.length))
      }
      if (g5) {
        ret.push(fillNumber(map.H, g5.length))
      }
      if (g6) {
        ret.push(fillNumber(map.m, g6.length))
      }
      if (g7) {
        ret.push(fillNumber(map.s, g7.length))
      }
      return ret.join('')
    }
  )
}

/**
 * @param startDate  开始日期 yyyy-MM-dd
 * @param enDate  结束日期 yyyy-MM-dd
 * @returns {number} 两日期相差的天数
 */
export function getDaysBetween(startDate: string, enDate: string) {
  const sDate = Date.parse(startDate)
  const eDate = Date.parse(enDate)
  if (sDate > eDate || sDate === eDate) {
    return 0
  }
  const days = Math.ceil((eDate - sDate) / (1 * 24 * 60 * 60 * 1000))
  return days
}

//获取url最后一个path路径（router path）
export const getLastPath = (value: string) => {
  const result =
    value &&
    value.split('?')[0].match('[^/]+(?!.*/)') &&
    (value.split('?')[0].match('[^/]+(?!.*/)') || [])[0]
  return result
}

export const parseQueryString = function (url: string) {
  if (url.indexOf('?') < 0) {
    return {}
  }
  const obj: any = {}
  let keyvalue = []
  let key = '',
    value = ''
  const paraString = url.substring(url.indexOf('?') + 1, url.length).split('&')
  for (const i in paraString) {
    keyvalue = paraString[i].split('=')
    if (keyvalue.length > 1) {
      key = keyvalue[0]
      value = keyvalue[1]
      obj[key] = value
    }
  }
  return obj
}

export function formatReserveTime(leftTime: number): ReserveTime {
  const secs = leftTime / 1000
  let min = ~~(secs / 60) as any
  let sec = ~~(secs % 60) as any
  if (min >= 0 && sec >= 0) {
    if (min < 10) {
      min = '0' + min.toString()
    }
    if (sec < 10) {
      sec = '0' + sec.toString()
    }
  } else {
    min = '00'
    sec = '00'
  }

  return {
    min: min,
    sec: sec
  }
}

export function getH5ContentURL(showId:string) {
  let h5URL = window.location.href;
  if (window.location.hostname === 'tqpc-qa.caiyicloud.com') {
    h5URL = `https://6269fa415f45b974fce3885e-qa.caiyicloud.com/content/${showId}`;
  } else if (window.location.hostname === 'tqpc-qad.caiyicloud.com') {
    h5URL = `https://pxqstage-qad.caiyicloud.com/content/${showId}`;
  } else if (window.location.hostname === 'tqpc.caiyicloud.com') {
    h5URL = `https://6704cebda217cf0001ef70b0.caiyicloud.com/content/${showId}`;
  } else {
    h5URL = `https://c.tqpac.com/content/${showId}`;
  }
  return h5URL;
}